import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./Auth/AuthProvider";
import { LogOut, X, Menu } from "lucide-react";
import { Button } from "./ui/button";
import ShweebumCat from "./ShweebumCat";

const SiteHeader = () => {
  const { user, logout } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-card border-b border-border sticky top-0 z-40">
      <div className="container mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <ShweebumCat size="sm" />
            <span className="font-literary text-xl text-foreground">Shweebum</span>
          </Link>
          
          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-muted-foreground hover:text-foreground text-sm">Home</Link>
            <Link to="/about" className="text-muted-foreground hover:text-foreground text-sm">About Us</Link>
            <Link to="/reviews" className="text-muted-foreground hover:text-foreground text-sm">Reviews</Link>
            <Link to="/pricing" className="text-muted-foreground hover:text-foreground text-sm">Pricing</Link>
            <Link to="/contact" className="text-muted-foreground hover:text-foreground text-sm">Contact</Link>
            {user ? (
              <div className="flex items-center gap-2">
                <Link to="/dashboard">
                  <Button size="sm" className="bg-cyan-700 hover:bg-cyan-800">Dashboard</Button>
                </Link>
                <Button 
                  size="sm" 
                  variant="ghost" 
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    localStorage.removeItem('shweebum_user');
                    localStorage.removeItem('shweebum_token');
                    sessionStorage.clear();
                    window.location.assign('/');
                  }} 
                  type="button"
                >
                  <LogOut className="w-4 h-4" />
                </Button>
              </div>
            ) : (
              <Link to="/">
                <Button size="sm" className="bg-cyan-700 hover:bg-cyan-800">Get Started</Button>
              </Link>
            )}
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Nav */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 space-y-2">
            <Link to="/" className="block py-2 text-muted-foreground">Home</Link>
            <Link to="/about" className="block py-2 text-muted-foreground">About Us</Link>
            <Link to="/reviews" className="block py-2 text-muted-foreground">Reviews</Link>
            <Link to="/pricing" className="block py-2 text-muted-foreground">Pricing</Link>
            <Link to="/contact" className="block py-2 text-muted-foreground">Contact</Link>
            {user ? (
              <Link to="/dashboard" className="block py-2 text-cyan-300 font-medium">Dashboard</Link>
            ) : (
              <Link to="/" className="block py-2 text-cyan-300 font-medium">Get Started</Link>
            )}
          </nav>
        )}
      </div>
    </header>
  );
};

export default SiteHeader;
